export const getFundNews = token =>
  fetch(`${process.env.GATSBY_FUNCTION_PATH}/get-fund-news`, {
    method: 'GET',
    headers: {
      token,
    },
  })

export const createFundNews = ({token, item}) =>
  fetch(`${process.env.GATSBY_FUNCTION_PATH}/create-fund-news`, {
    method: 'POST',
    headers: {
      token,
    },
    body: JSON.stringify({item}),
  })

export const editFundNews = ({token, itemId, item}) =>
  fetch(`${process.env.GATSBY_FUNCTION_PATH}/edit-fund-news?id=${itemId}`, {
    method: 'POST',
    headers: {
      token,
    },
    body: JSON.stringify({item}),
  })

export const deleteFundNews = ({token, item}) => {
  return fetch(`${process.env.GATSBY_FUNCTION_PATH}/delete-fund-news`, {
    method: 'POST',
    body: JSON.stringify({
      item,
    }),
    headers: {
      token,
    },
  })
}
